// src/router/alertaAgendado.js
// Registrado automaticamente pelo auto-glob em src/router/index.js

const alertaAgendadoBreadCrumb = [
  {
    label: 'Home',
    to: 'Home'
  },
  {
    label: 'Alertas agendados',
    to: 'AlertaAgendadoList'
  }
]

export default [
  {
    path: '/alertas-agendados',
    name: 'AlertaAgendadoList',
    component: () => import('@/views/AlertaAgendado/AlertaAgendadoListPage.vue'),
    meta: {
      // A API só aceita admin nessas rotas; sem o guard a tela abriria e falharia em todas as chamadas.
      roles: ['admin'],
      title: 'Alertas agendados',
      breadcrumb: alertaAgendadoBreadCrumb
    }
  }
]
